import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.module.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HomeScreen } from './screens/Home';
import { ContactScreen } from './screens/Contact';
import { AboutScreen } from './screens/About';
import { EventRedirectScreen } from './screens/EventRedirectScreen';
import './i18n';
import { NotFound } from './screens/NotFound';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <HomeScreen />,
      },
      {
        path: "about",
        element: <AboutScreen />,
      },
      {
        path: "contact",
        element: <ContactScreen />,
      },
      {
        path: "event/:eventId",
        element: <EventRedirectScreen />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();